// keep synchronized with vestwell-admin-api
import { AlertSubType } from '@vestwell-sub-accounting/models/common/AlertSubType';
import { AlertType } from '@vestwell-sub-accounting/models/common/AlertType';

import { AchReversalAlertDto } from './ach-reversal-alert-dto.model';
import { AlertCommonProps } from './alert-common-props.model';
import { CashTransferRejectedAlertDto } from './cash-transfer-rejected-alert-dto.model';
import { ConductorAlertDto } from './conductor-alert-dto.model';
import { DepositAlertDto } from './deposit-alert-dto.model';
import { DisbursementRequestAlertDto } from './disbursement-request-alert-dto.model';
import { TradingAlertDto } from './trading-alert-dto.model';

export type GenericAlertDto = AlertCommonProps & {
  alertType: `${AlertType}`;
  alertSubType: `${AlertSubType}` | null;
  details: {
    [key: string]: unknown;
  };
};

export type AlertDto =
  | AchReversalAlertDto
  | CashTransferRejectedAlertDto
  | ConductorAlertDto
  | DisbursementRequestAlertDto
  | DepositAlertDto
  | GenericAlertDto
  | TradingAlertDto;

export type AlertsResponse = {
  data: AlertDto[];
};

export type AlertTypeTotals = { [key in AlertType]?: number };

export const isAchReversalAlert = (
  alert: AlertDto
): alert is AchReversalAlertDto => {
  return (
    alert.alertSubType === AlertSubType.ACHReversal && 'notice' in alert.details
  );
};

export const isCashTransferRejectedAlert = (
  alert: AlertDto
): alert is CashTransferRejectedAlertDto => {
  return (
    alert.alertType === AlertType.MoneyIn &&
    alert.alertSubType === AlertSubType.CashTransferRejected
  );
};

export const isConductorAlert = (
  alert: AlertDto
): alert is ConductorAlertDto => {
  return alert.alertType === AlertType.Conductor;
};

export const isDepositAlert = (alert: AlertDto): alert is DepositAlertDto => {
  return (
    (alert.alertType === AlertType.MoneyIn &&
      alert.alertSubType === AlertSubType.ACHReversal) ||
    (alert.alertType === AlertType.Conversion &&
      alert.alertSubType === AlertSubType.NewConversionDeposit) ||
    (alert.alertType === AlertType.Rollovers &&
      alert.alertSubType === AlertSubType.NewRolloverDeposit) ||
    (alert.alertType === AlertType.MoneyIn &&
      alert.alertSubType === AlertSubType.UnclassifiedDeposit) ||
    (alert.alertType === AlertType.MoneyIn &&
      alert.alertSubType === AlertSubType.CheckDepositReversal)
  );
};

export const isLegacyAchReversalAlert = (
  alert: AlertDto
): alert is DepositAlertDto => {
  return (
    alert.alertSubType === AlertSubType.ACHReversal && 'event' in alert.details
  );
};

export const isTradingAlert = (alert: AlertDto): alert is TradingAlertDto => {
  return alert.alertType === AlertType.Trading;
};
